import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SmsRoutingModule } from '@modules/sms/sms-routing.module';
import { NgbDropdownModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { UiModule } from '@ui/ui.module';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SmsLinkAnalyticsComponent } from './components/sms-link-analytics/sms-link-analytics.component';
import { SmsRecurringComponent } from 'src/app/views/sms/sms-history/sms-recurring/sms-recurring.component';
import { SmsScheduledComponent } from 'src/app/views/sms/sms-history/sms-scheduled/sms-scheduled.component';
import { SmsSentComponent } from 'src/app/views/sms/sms-history/sms-sent/sms-sent.component';
import { SmsPeriodicComponent } from 'src/app/views/sms/sms-history/sms-periodic/sms-periodic.component';
import { SmsHistoryComponent } from 'src/app/views/sms/sms-history/sms-history.component';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AppSharedModule } from 'src/app/app-shared.module';

@NgModule({
  declarations: [
    SmsPeriodicComponent,
    SmsHistoryComponent,
    SmsRecurringComponent,
    SmsScheduledComponent,
    SmsSentComponent,
    SmsLinkAnalyticsComponent
  ],
  exports: [],
  imports: [
    CommonModule,
    AppSharedModule,
    SmsRoutingModule,
    NgbNavModule,
    MatTooltipModule,
    UiModule,
    InlineSVGModule.forRoot(),
    TranslateModule.forChild({
      extend: true
    }),
    ReactiveFormsModule,
    NgbDropdownModule
  ]
})
export class SmsModule {}
